import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { Spinner } from "react-bootstrap";
import { PostRequest } from "../../utils/ApiServices";

function TabbyPayment() {
  const navigate = useNavigate();
  const [myJwtCookie] = useCookies(["jwt"]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+971");

  const countryCodes = [
    { code: "+971", label: "UAE (+971)" },
    { code: "+966", label: "KSA (+966)" },
    { code: "+965", label: "Kuwait (+965)" },
    { code: "+968", label: "Oman (+968)" },
    { code: "+974", label: "Qatar (+974)" },
    { code: "+973", label: "Bahrain (+973)" },
    { code: "+91", label: "India (+91)" },
    { code: "+44", label: "UK (+44)" },
    { code: "+1", label: "US (+1)" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fullName || fullName.trim().length < 2) {
      setError("Please enter your full name.");
      return;
    }

    if (!email || !email.includes("@") || !email.includes(".")) {
      setError("Please enter a valid email address.");
      return;
    }

    if (!phoneNumber || phoneNumber.length < 7) {
      setError("Please enter a valid phone number.");
      return;
    }

    setError(null);

    try {
      setIsLoading(true);
      const cart = JSON.parse(localStorage.getItem("cart")) || [];
      const user = myJwtCookie.user;

      if (!user) {
        navigate("/login");
        return;
      }

      const sum = cart.reduce((acc, curr) => {
        let price = curr.price;
        return acc + price * (curr?.enrolment_quantity || 1);
      }, 0);
      const amount = sum + sum * 0.05;
      const promocode = localStorage.getItem("promoCode") ?? null;

      const fullPhone = `${countryCode}${phoneNumber}`;

      const postData = {
        amount: amount.toFixed(2),
        courses: cart,
        customer_id: user.id,
        code: promocode,
        payment_gateway: "tabby",
        buyer: {
          phone: fullPhone,
          email: email.trim(),
          name: fullName.trim(),
        }
      };

      let requiredFields = null;
      try {
        requiredFields = JSON.parse(localStorage.getItem("requiredFields"));
      } catch {
        console.log("error while parsing requiredFields");
      }

      if (requiredFields) {
        postData.requiredFields = requiredFields;
      }

      const response = await PostRequest("gotocheckout", postData);

      if (response && response.status === "success" && response.web_url) {
        window.location.href = response.web_url;
      } else {
        setError(response?.message || "Failed to initialize Tabby session.");
      }
    } catch (err) {
      console.error("Tabby Session Error:", err);
      setError("An error occurred while connecting to the checkout service.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .tabby-wrapper {
          min-height: 60vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px 16px;
        }
        .tabby-card {
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 4px 24px rgba(0,0,0,0.10);
          padding: 40px 36px;
          text-align: center;
          width: 100%;
          max-width: 520px;
          margin: 0 auto;
          box-sizing: border-box;
        }
        .tabby-title {
          font-size: 28px;
          font-weight: 700;
          color: #292929;
          letter-spacing: -0.5px;
          margin-bottom: 8px;
        }
        .tabby-title span {
          color: #36D5C7;
        }
        .tabby-subtitle {
          color: #666;
          font-size: 14px;
          margin-bottom: 24px;
        }
        .tabby-label {
          display: block;
          text-align: left;
          font-size: 14px;
          font-weight: 600;
          color: #444;
          margin-bottom: 6px;
        }
        .tabby-input {
          width: 100%;
          padding: 12px 16px;
          border-radius: 10px;
          border: 1.5px solid #e0e0e0;
          font-size: 15px;
          outline: none;
          transition: border-color 0.2s ease;
          box-sizing: border-box;
        }
        .tabby-input:focus {
          border-color: #36D5C7;
        }
        .tabby-field {
          margin-bottom: 16px;
        }
        .tabby-phone-row {
          display: flex;
          gap: 8px;
        }
        .tabby-select {
          width: 140px;
          min-width: 120px;
          padding: 12px 8px;
          border-radius: 10px;
          border: 1.5px solid #e0e0e0;
          font-size: 14px;
          background: #fafafa;
          color: #333;
          cursor: pointer;
          outline: none;
          box-sizing: border-box;
        }
        .tabby-select:focus {
          border-color: #36D5C7;
        }
        .tabby-phone-input {
          flex: 1;
          min-width: 0;
          letter-spacing: 1px;
        }
        .tabby-btn {
          width: 100%;
          padding: 14px;
          border-radius: 10px;
          border: none;
          background: #36D5C7;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          margin-top: 8px;
        }
        .tabby-btn:hover {
          background: #2bc4b6;
        }
        .tabby-btn:disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }
        .tabby-back {
          margin-top: 16px;
          background: none;
          border: none;
          color: #888;
          font-size: 14px;
          cursor: pointer;
          text-decoration: underline;
        }
        .tabby-back:hover {
          color: #36D5C7;
        }

        @media (max-width: 576px) {
          .tabby-card {
            padding: 28px 20px;
            border-radius: 12px;
          }
          .tabby-title {
            font-size: 24px;
          }
          .tabby-phone-row {
            flex-direction: column;
            gap: 10px;
          }
          .tabby-select {
            width: 100%;
          }
        }
      `}</style>

      <div className="section section-padding tabby-wrapper">
        <div className="tabby-card">
          {/* Tabby Header */}
          <div className="tabby-title">
            Pay with <span>tabby</span>
          </div>
          <p className="tabby-subtitle">
            Please fill in your details to proceed with Tabby payment.
          </p>

          {error && (
            <div className="alert alert-danger" style={{ fontSize: "14px", borderRadius: "8px" }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Full Name */}
            <div className="tabby-field">
              <label className="tabby-label">Full Name</label>
              <input
                type="text"
                className="tabby-input"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="John Doe"
              />
            </div>

            {/* Email */}
            <div className="tabby-field">
              <label className="tabby-label">Email Address</label>
              <input
                type="email"
                className="tabby-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="john@example.com"
              />
            </div>

            {/* Phone Number */}
            <div className="tabby-field" style={{ marginBottom: "24px" }}>
              <label className="tabby-label">Mobile Number</label>
              <div className="tabby-phone-row">
                <select
                  className="tabby-select"
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                >
                  {countryCodes.map((c) => (
                    <option key={c.code} value={c.code}>{c.label}</option>
                  ))}
                </select>
                <input
                  type="tel"
                  className="tabby-input tabby-phone-input"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, ""))}
                  placeholder="5XXXXXXXX"
                  maxLength={12}
                />
              </div>
            </div>

            <button type="submit" className="tabby-btn" disabled={isLoading}>
              {isLoading ? (
                <><Spinner animation="border" size="sm" /> Redirecting to Tabby...</>
              ) : (
                "Continue to Tabby"
              )}
            </button>
          </form>

          <button className="tabby-back" onClick={() => navigate("/cart")}>
            ← Return to Cart
          </button>
        </div>
      </div>
    </>
  );
}

export default TabbyPayment;
